// Bridge for the APP-7397 remote sync/async rollout flag — Rust cannot read
// Flagsmith, so the FE pushes the value; the plugin defaults to false (dark).
import { isTauri } from '@/tauri/utils';
import { logger } from '@/utils/logger/logger';

export async function setRemoteSyncAsyncEnabled(enabled: boolean): Promise<void> {
  if (!isTauri()) return;
  try {
    const { invoke } = await import('@tauri-apps/api/core');
    await invoke<void>('chronicle_set_remote_sync_async_enabled', { enabled });
  } catch (error) {
    logger.error('[remoteSyncAsync] Failed to push flag to Rust:', error);
  }
}

export async function setRemoteRecordingDedupEnabled(enabled: boolean): Promise<void> {
  if (!isTauri()) return;
  try {
    const { invoke } = await import('@tauri-apps/api/core');
    await invoke<void>('chronicle_set_remote_recording_dedup_enabled', { enabled });
  } catch (error) {
    logger.error('[remoteRecordingDedup] Failed to push flag to Rust:', error);
  }
}
